import { useCallback, useEffect, useRef } from 'react';

const useToast = () => {
  const toastRef = useRef<HTMLElement | null>(null);
  const toastMessageRef = useRef<HTMLElement | null>(null);
  let timer: NodeJS.Timeout;

  const openToast = useCallback(
    (message) => {
      clearTimeout(timer);
      if (toastMessageRef.current && toastRef.current) {
        toastMessageRef.current.textContent = message;
        toastRef.current.style.opacity = '1';
        timer = setTimeout(() => {
          toastRef.current!.style.opacity = '0';
        }, 2000);
      }
    },
    [toastRef, toastMessageRef],
  );

  useEffect(() => {
    const toast = document.getElementById('toast');
    const toastMessage = document.getElementById('toast-message');

    toastRef.current = toast;
    toastMessageRef.current = toastMessage;
  }, []);

  return {
    openToast,
  };
};

export default useToast;
